import {Component, ViewEncapsulation} from '@angular/core';
import {AdvisorComponent} from "../advisor.component";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {EmbedService} from "../services/embed.service";
import {TrackingService} from "../services/tracking.service";
import {ModeratBackendService} from "./services/backend.service";
import {environment} from "../../environments/environment";
import {PortalService} from "../services/portal.service";

/**
 * The moderat component as wrapper for all steps of the application.
 * Attention: The mentioned scss file here will be replaced in angulaar.json and will not be included
 * in the deployment package. This is for development purpose only.
 */
@Component({
    selector: 'moderat-root',
    templateUrl: './moderat.component.html',
    styleUrls: environment.stylePath,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModeratComponent extends AdvisorComponent {


  /**
   * constructor
   * @param translate
   * @param router
   * @param embedService
   * @param trackingService
   * @param backendService
   */
  constructor(public translate: TranslateService, protected router: Router, protected embedService: EmbedService, protected trackingService: TrackingService,
              protected backendService: ModeratBackendService) {
    super(translate, router, embedService, trackingService);

    this.backendService.setAdvisor('moderat');
  }


}
